import { pond } from "protobuf-ts/pond";

//function is deprecated, use User.tempUnit() instead
export function getTemperatureUnit(): pond.TemperatureUnit {
  return localStorage.getItem("temperature") === "f"
    ? pond.TemperatureUnit.TEMPERATURE_UNIT_FAHRENHEIT
    : pond.TemperatureUnit.TEMPERATURE_UNIT_CELSIUS;
}

export function setTemperatureUnit(unit: pond.TemperatureUnit) {
  localStorage.setItem(
    "temperature",
    unit === pond.TemperatureUnit.TEMPERATURE_UNIT_FAHRENHEIT ? "f" : "c"
  );
}

/**
 * takes in the celsius value for temperature and returns the fahrenheit value
 * @param celsius celsius value
 * @returns temperature in fahrenheit
 */
export const celsiusToFahrenheit = (celsius: number) => {
  return celsius * (9 / 5) + 32;
};

/**
 * takes in the fahrenheit value for temperature and returns the celsius value
 * @param fahrenheit starting value
 * @returns temperature in celsius
 */
export const fahrenheitToCelsius = (fahrenheit: number) => {
  return (fahrenheit - 32) * (5 / 9);
};

// function is deprecated, use User.pressureUnit() instead
export function getPressureUnit(): pond.PressureUnit {
  return localStorage.getItem("pressure") === "kpa"
    ? pond.PressureUnit.PRESSURE_UNIT_KILOPASCALS
    : pond.PressureUnit.PRESSURE_UNIT_INCHES_OF_WATER;
}

export function setPressureUnit(unit: pond.PressureUnit) {
  localStorage.setItem(
    "pressure",
    unit === pond.PressureUnit.PRESSURE_UNIT_KILOPASCALS ? "kpa" : "iwg"
  );
}

// function is deprecated, use User.distanceUnit() instead
export function getDistanceUnit(): pond.DistanceUnit {
  return localStorage.getItem("distance") === "m"
    ? pond.DistanceUnit.DISTANCE_UNIT_METERS
    : pond.DistanceUnit.DISTANCE_UNIT_FEET;
}

export function setDistanceUnit(unit: pond.DistanceUnit) {
  localStorage.setItem("distance", unit === pond.DistanceUnit.DISTANCE_UNIT_METERS ? "m" : "ft");
}

// function is deprecated, use User.grainUnit() instead
export function getGrainUnit(): pond.GrainUnit {
  switch(localStorage.getItem("grainUnit")){
    case "mT":
      return pond.GrainUnit.GRAIN_UNIT_TONNE
    case "t":
      return pond.GrainUnit.GRAIN_UNIT_TON
    default:
      return pond.GrainUnit.GRAIN_UNIT_BUSHELS
  }

  // return localStorage.getItem("grainUnit") === "mT"
  //   ? pond.GrainUnit.GRAIN_UNIT_WEIGHT
  //   : pond.GrainUnit.GRAIN_UNIT_BUSHELS;
}

export function setGrainUnit(unit: pond.GrainUnit) {
  switch(unit){
    case pond.GrainUnit.GRAIN_UNIT_WEIGHT:
    case pond.GrainUnit.GRAIN_UNIT_TONNE:
      localStorage.setItem("grainUnit", "mT")
      break;
    case pond.GrainUnit.GRAIN_UNIT_TON:
      localStorage.setItem("grainUnit", "t")
      break;
    default:
      localStorage.setItem("grainUnit", "bu")
  }
}

export const distanceConversion = (val: number, distanceUnit: pond.DistanceUnit) => {
  let converted = val;
  if (distanceUnit === pond.DistanceUnit.DISTANCE_UNIT_METERS) {
    converted = val / 3.281;
  }
  return converted;
};
